import React, { useState, useEffect, useRef } from 'react';
import stilePulsanti from '../../interfaccia/stilePulsanti';
import { CSVLink/* , CSVDownload  */} from "react-csv";
import TastoSelezionaTab from '../../logistica/AreaOrdiniComponenti/OrdineComponenti/TastoSelezionaTab';
import beep from "../../files/sounds/beep-6-96243.mp3";
import errorSound from  "../../files/sounds/error-call-to-attention-129258.mp3";

function Inventario({}) {

    const [barcodeSparati,setBarcodeSparati] = useState([]);
    const [input, setInput] = useState("");
    const [index, setIndex] = useState(0);
    const [title, setTitle] = useState("");
    const [schermata,setSchermata] = useState("home")
    const [archivio,setArchivio] = useState([])
    const suonoConferma = new Audio(beep);
    const suonoErrore = new Audio(errorSound);

    const {
        buttonClassesWhite,
        vociMenuTabs,
        vociMenuTabsSelezionata,
        tastoCancellaAspetto,
        buttonClassesRed,
        inputClassesNOW
    } = stilePulsanti
    

    const today = new Date();

    function toString(number, padLength) {
        return number.toString().padStart(padLength, '0');
    }

    let dateTimeNow =
          '_'  + toString( today.getFullYear(),     4 )
        + '_'  + toString( today.getMonth() + 1,    2 )
        + '_'  + toString( today.getDate(),         2 )
        + '_' + toString( today.getHours(),        2 )
        + '_'  + toString( today.getMinutes(),      2 )
    ;    

    const ref = useRef(null);

  useEffect(() => {
    ref.current.focus();
  }, []);

    const handleInput = async function (evt) {
        const value = evt.target.value;

        try {
            setInput(value)
        } catch (err) {
            console.log("Errore nel cambio dello stato input: " + err)
            throw err;
        }
    }

    const handleKeyDown = async function (event) {
        if (schermata === "home") {
            if (event.key === 'Enter') {
                event.preventDefault();    
                setBarcodeSparati([...barcodeSparati,{val:input,index:index,quant:1,unit:""}]);
                setIndex(index+1)
                setInput("");
                if (!input) {
                    suonoErrore.play();
                } else if (input.length>11 && input.length<16) {
                    suonoConferma.play();
                } else {
                    suonoErrore.play();
                }
            } else if (event.keyCode>0 && event.keyCode<229) {
                if (!input) {
                    setInput(event.key)
                } else {
                    setInput(input.concat(event.key))
                }
            }
        }
    };

    const rimuovi = function(e,i) {
        e.preventDefault();
        const arrFiltrata = barcodeSparati.filter(obj => {
            return obj.index !== i
        })
        setBarcodeSparati(arrFiltrata);
    }

    const cancellaTutto = async function(e) {
        e.preventDefault();
        let sicuro = window.confirm("Stai per cancellare tutti i codici sparati, confermi? (Se hai salvato un file, quei codici sono al sicuro)");
        if (sicuro) {
            setBarcodeSparati([]);
        }
    }    

    const changeTitle = async function(evt) {
        evt.preventDefault();
        const value = evt.target.value;

        try {
            setTitle(value)
        } catch (err) {
            console.log("Errore nel cambio del titolo: " + err)
            throw err;
        }
    }

    const archivia = function() {
        setArchivio([...archivio, {titolo: title+dateTimeNow+".csv", barcode: barcodeSparati}])
        setBarcodeSparati([])
    }

    const headers = [
        { label: "CODICE", key: "val" },
        { label: "UNIMIS", key: "unit" },
        { label: "QTAMOV", key: "quant" }
      ];
    
   return (
            <div ref={ref} tabIndex={-1} onKeyDown={handleKeyDown} className="sfondoBiancoTema br3 colonnaTuttaPagina">
                <div className='flex justify-between pl4 pr4 items-center'>
                <div className='b f4'>Inventario</div>
                <div className='flex'>
                    <TastoSelezionaTab
                        idTasto="home"
                        onClickTasto={() => setSchermata("home")}
                        tab={schermata}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata+" pr2"}
                        vociMenuTabs={vociMenuTabs+" pr2"}
                        icona="home"
                        testo="Spara"
                    />
                    <TastoSelezionaTab
                        idTasto="save"
                        onClickTasto={() => setSchermata("save")}
                        tab={schermata}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata+" pr2"}
                        vociMenuTabs={vociMenuTabs+" pr2"}
                        icona="save"
                        testo="Salva"
                    />
                    <TastoSelezionaTab
                        idTasto="archive"
                        onClickTasto={() => setSchermata("archive")}
                        tab={schermata}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata+" pr2"}
                        vociMenuTabs={vociMenuTabs+" pr2"}
                        icona="history"
                        testo="Archivio"
                    />
                </div>
                </div>                
                <div className="center tc">
                    {schermata === "save" && 
                    <div>
                        <div className="mt4 mb4 f4">Imposta un nome e salva</div>
                    <input
                        type="text"
                        id="title"
                        name="title"
                        value={title}
                        autoComplete="off"
                        onChange={changeTitle}
                        className={inputClassesNOW+" ml2 mr2"}
                        onKeyDown={handleKeyDown}
                    /><CSVLink data={barcodeSparati} headers={headers} separator={";"} enclosingCharacter={``} className={stilePulsanti.buttonClassesWhite} target="_blank" filename={title+dateTimeNow+".csv"}>scarica</CSVLink>
                    <div className="mb2">Il file si chiamerà {title+dateTimeNow+".csv"}</div>
                    <div className="mt4 mb2 pr4 pl4 b f5">Dopo aver scaricato il file puoi archiviare i codici sparati.</div>
                    <div className="mb4 f6  pr4 pl4">Li potrai trovare e scaricare dalla sezione archivio per la durata della sessione. Quando ricarichi o chiudi la pagina i dati verranno persi.</div>
                    <button className={buttonClassesWhite} onClick={archivia}>Archivia i codici</button>
                    
                    </div>}
                    {/* {schermata === "home" && <div>
                    <h3>Assicurati che il cursore lampeggi e spara il barcode</h3>
                    <input
                        autoFocus
                        type="text"
                        id="input"
                        name="input"
                        value={input}
                        autoComplete="off"
                        onChange={handleInput}
                        className={stilePulsanti.inputClassesConTasto}
                        onKeyDown={handleKeyDown}
                    />
                    </div>} */}
                    {schermata === "archive" && <div>
                    <h3>Archivio</h3>
                    {archivio.map((barcodeArchiviati,i) => {
                        return(
                            <div className='flex items-center justify-between mb2'>
                                <div className='mr2'>{(i+1)+" - "}<strong>{barcodeArchiviati.titolo}</strong></div>
                                <CSVLink data={barcodeArchiviati.barcode} headers={headers} separator={";"} enclosingCharacter={``} className={buttonClassesWhite} target="_blank" filename={barcodeArchiviati.titolo}>scarica</CSVLink>
                            </div>
                        )
                    })}
                    </div>}
                    {schermata === "aiuto" && <div className='pa4 tl'>
                    <div className="b f3">Impostazioni terminalino</div>
                    <p className='f4 mt4'>
                        Se il terminale emette un suono ma il barcode non viene salvato, probabilmente devi ancora configurarlo:
                    </p>
                    <li className='f4 mt2'>nelle notifiche del dispositivo apri "Barcode Tray"</li>
                    <li className='f4 mt2'>poi seleziona "Scan setting"</li>
                    <li className='f4 mt2'>"Data Receive Method"</li>
                    <li className='f4 mt2'>imposta "KEYBOARD_EVENT"</li>
                    <p className='f4 mt4'>
                        Se invece il terminale è configurato correttamente ma non ottieni risultati, prova a toccare una volta lo sfondo bianco sotto il tasto aiuto e prova a sparare nuovamente.
                    </p>
                    <button className={buttonClassesWhite+" f4 mt4"} onClick={() => setSchermata("home")}>ok dai ci provo</button>
                    </div>}
                </div>
                {schermata === "home" && 
                <div className='tutto h-100'>
                    <div className="align-end tc pa3">
                    <h3>Pezzi sparati: {barcodeSparati.length}</h3>
                    {barcodeSparati.length === 0 && <div className='pa4'><div className='f3'>sono pronto, spara!</div><div className='f5 mt2'><button className={buttonClassesWhite+" mt3"} onClick={() => setSchermata("aiuto")}>aiuto</button>{/* Se il barcode non viene salvato, tocca un punto qualunque qui sotto e prova di nuovo */}</div></div>}
                    </div>
                    <div className='tc pa4 sezInv3 h-100'>                    
                        {barcodeSparati.map((cod) => <div className='barcodeSparato flex justify-between bb bordoColAlt mb2 items-center'>{cod.val} <div className=" ml2 pointer" onClick={(e) => rimuovi(e,cod.index)}>{tastoCancellaAspetto}</div></div>)}
                    <div className='pa4'>
                    {barcodeSparati.length > 0 && <div className={buttonClassesRed+""} onClick={(e) => cancellaTutto(e)}>cancella tutto</div>}
                    </div>
                    </div>
                </div>}
            </div>
            
        );

}

export default Inventario;